import { Badge } from '@sequencehq/core-components'

export const SeatTypeBadge = ({
  seatType,
  'data-testid': dataTestId
}: {
  seatType: string
  'data-testid'?: string
}) => {
  return (
    <Badge
      sentiment="neutral"
      size="sm"
      textTransform="none"
      data-testid={dataTestId}
      truncate
    >
      {seatType}
    </Badge>
  )
}
